import React, { useState, useEffect } from 'react';

export default function useTable(records, headCells, filterFn) {
    const pages = [10, 25, 50];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pages[page]);
    const [order, setOrder] = useState();
    const [orderBy, setOrderBy] = useState();

    const TblContainer = (props) => (
        <div style={{ height: '420px', overflowY: 'auto', width: '100%' }} {...props}>
            <table className="table table-striped table-hover table-sm border-table">
                {props.children}
            </table>
        </div>
    );

    useEffect(() => {
        setPage(0);
    }, [filterFn]);

    const TblHead = (props) => {
        const handleSortRequest = (cellId) => {
            const isAsc = orderBy === cellId && order === "asc";
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(cellId);
        };

        return (
            <thead>
                <tr>
                    {headCells.map((headCell) => (
                        <th
                        className='letra-tabla-th'
                            key={headCell.id}
                            style={{
                                fontFamily: headCell.fontFamily,
                                textAlign: headCell.textAlign,
                                fontWeight: 'bold',
                                backgroundColor: headCell.backgroundColor,
                                color: headCell.color,
                                fontSize: '12px',
                                padding: headCell.padding,
                                margin: headCell.margin, 
                            }}
                            onClick={() => {
                                if (!headCell.disableSorting) handleSortRequest(headCell.id);
                            }}
                        >
                            {headCell.label}
                        </th>
                    ))}
                </tr>
            </thead>
        );
    };

    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const TblPagination = () => {
        const totalRecords = records.length;
        const totalPages = Math.ceil(totalRecords / rowsPerPage);
        const startIndex = page * rowsPerPage + 1;
        const endIndex = Math.min(totalRecords, (page + 1) * rowsPerPage);

        return (

            /*     <ul class="page">
        <li class="page__btn"><span class="material-icons">chevron_left</span></li>
        <li class="page__numbers"> 1</li>
        <li class="page__numbers active">2</li>
        <li class="page__numbers">3</li>
        <li class="page__numbers">4</li>
        <li class="page__numbers">5</li>
        <li class="page__numbers">6</li>
        <li class="page__dots">...</li>
        <li class="page__numbers"> 10</li>
        <li class="page__btn"><span class="material-icons">chevron_right</span></li>
      </ul> */

            <div className="pagination">
                <div className="pagination-info my-auto px-2">
                    Filas {startIndex}–{endIndex} de {totalRecords}
                </div>
                <button
                    onClick={() => handleChangePage(page - 1)}
                    disabled={page === 0}
                    
                >
                   <i class="fas fa-caret-left"></i>
                </button>
                {/*  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => handleChangePage(index)}
                        className={`page-number ${page === index ? 'active' : ''}`}
                    >
                        {index + 1}
                    </button>
                ))} */}
                <button
                    onClick={() => handleChangePage(page + 1)}
                    disabled={page >= totalPages - 1}
                    
                >
                  <i class="fas fa-caret-right"></i>
                </button>
                <select value={rowsPerPage}  onChange={handleChangeRowsPerPage}>
                    {pages.map((pageSize) => (
                        <option key={pageSize} value={pageSize}>
                            {pageSize}
                        </option>
                    ))}
                </select>
            </div>
        );
    };

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    const recordsAfterPagingAndSorting = () => {
        return stableSort(filterFn.fn(records), getComparator(order, orderBy))
            .slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    };

    return {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting,
    };
}
